export const TESTIMONIAL_CREATE_RESET = 'TESTIMONIAL_CREATE_RESET';
export const TESTIMONIAL_CREATE_SET_CREATED = 'TESTIMONIAL_CREATE_SET_CREATED';
export const TESTIMONIAL_CREATE_SET_ERROR = 'TESTIMONIAL_CREATE_SET_ERROR';
export const TESTIMONIAL_CREATE_SET_VIOLATIONS = 'TESTIMONIAL_CREATE_SET_VIOLATIONS';
export const TESTIMONIAL_CREATE_TOGGLE_LOADING = 'TESTIMONIAL_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/create/mutation_types.js